const SetProcessVariablesRequest = function() {
  return {
    processId: "",
    variableList: []
  };
};

export default SetProcessVariablesRequest;



// WEBPACK FOOTER //
// ./src/service/request/SetProcessVariablesRequest.js